import { POST } from '@/server/http';
import URLS from '@/server/urls';

export default async ({
    cate = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.dictionary.getList, {
        cate,
    }, options);
    if (error) return { error, status };
    return content || { rows: [] };
};
